var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0378 78C17.5179 78 0 60.5576 0 39.0378C0 17.5179 17.5179 0 39.0378 0C60.5576 0 78.0755 17.5179 78.0755 39.0378C78.0755 60.5576 60.5576 78 39.0378 78ZM39.0378 2.49177C18.8771 2.49177 2.49177 18.8771 2.49177 39.0378C2.49177 59.1984 18.8771 75.5082 39.0378 75.5082C59.1984 75.5082 75.5082 59.1229 75.5082 39.0378C75.5082 18.9526 59.1229 2.49177 39.0378 2.49177Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5575 53.1577C60.5575 53.8373 60.0289 54.3658 59.3494 54.3658H41.9825C41.5294 55.4984 40.3968 56.329 39.0377 56.329C37.6785 56.329 36.5459 55.4984 36.0928 54.3658H18.726C18.0464 54.3658 17.5178 53.8373 17.5178 53.1577C17.5178 52.4781 18.0464 51.9495 18.726 51.9495H36.0928C36.5459 50.8169 37.6785 49.9863 39.0377 49.9863C40.3968 49.9863 41.5294 50.8169 41.9825 51.9495H59.3494C60.0289 51.874 60.5575 52.4781 60.5575 53.1577Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4424 21.6709V47.0417H60.5576V21.6709H17.4424ZM58.1413 44.6254H19.8586V24.1627H58.1413V44.6254Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7765 33.2993L36.0175 28.2402C35.64 28.0137 35.1869 28.0137 34.8094 28.2402C34.4318 28.4667 34.2053 28.8443 34.2053 29.2973V39.4154C34.2053 39.8685 34.4318 40.246 34.8094 40.4725C34.9604 40.548 35.1869 40.6236 35.4135 40.6236C35.64 40.6236 35.8665 40.548 36.0175 40.4725L44.7765 35.4135C45.154 35.187 45.3805 34.8094 45.3805 34.3564C45.3805 33.9033 45.154 33.5258 44.7765 33.2993ZM36.6216 37.3012V31.4115L41.7561 34.3564L36.6216 37.3012Z",
    fill: "url(#paint3_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 39.0128,
    x2: 78.0257,
    y2: 39.0128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79B943"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 27.9738,
    y1: 64.1672,
    x2: 50.0517,
    y2: 42.0894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4F53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A9B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 21.8924,
    y1: 51.488,
    x2: 56.1333,
    y2: 17.2471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79B943"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 32.9038,
    y1: 38.6944,
    x2: 41.5583,
    y2: 30.0399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79B943"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearn);
export default __webpack_public_path__ + "static/media/learn.60861c9c973f93184a239f3fd0bde4e7.svg";
export { ForwardRef as ReactComponent };